export function taskAge(createdAtMs, nowMs) {
  if (!Number.isFinite(createdAtMs)) return null;
  const minutes = Math.max(0, Math.floor((nowMs - createdAtMs) / 60000));
  const days = Math.floor(minutes / 1440);
  const hours = Math.floor((minutes % 1440) / 60);
  return `${days > 0 ? `${days} ${days === 1 ? "day" : "days"} ` : ""}${String(hours).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}hr ago`;
}
